import React from "react";
import {ActionButton} from "../ActionButton";

interface LinkButtonProps {
  onClick: () => void;
  label: string;
}

export const LinkButton = ({ onClick, label }: LinkButtonProps) => (
  <ActionButton
    label={label}
    onClick={onClick}
    iconName="fa-link"
  />
)